import {PaginatedType} from './../../../types';
import {AxiosResponse} from 'axios';
import {api, API_URL} from '../../config';
import {ItransactionReq} from './types';
import {ITransaction} from '../../../entities/logs';

const BASE_PATH = 'shops';

export const getTransactionsReuest = (
	shop_id: number,
	params: ItransactionReq,
): Promise<AxiosResponse<PaginatedType<ITransaction>>> => {
	return api.get<PaginatedType<ITransaction>>(
		`${API_URL}/${BASE_PATH}/${shop_id}/loyalty/cards/transactions`,
		{
			params: {
				...params,
			},
		},
	);
};
